'use client';

import Icon from './Icon';
import svg from 'sprites/human-athlete.svg';

export default function IconHumanAthlete({
  className = 'w-17 h-5 fill-none stroke-brown'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
